module.exports = __webpack_public_path__ + "img/eco_worthy_30Ah.1ce344b6.png";